"use client"

import { AlertTriangle } from "lucide-react"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { Marquee } from "@shared/ui/landing/marquee"
import { LiveBadge, StatusTag } from "@shared/ui/landing/status-tag"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { useLocale, useTranslations } from "@/lib/i18n/client"
import {
  formatThreatTime,
  severityVariant,
  threatEvents,
} from "@/lib/live-data"

export function ThreatCenterSection() {
  const t = useTranslations("threatCenter")
  const locale = useLocale()

  const tickerItems = threatEvents.map((event) => (
    <GlassCard
      key={event.id}
      className="cyber-border flex w-72 shrink-0 items-start gap-3 p-4"
    >
      <AlertTriangle className="mt-0.5 size-4 shrink-0 text-amber-400" />
      <div className="min-w-0 space-y-1">
        <div className="flex items-center gap-2">
          <StatusTag variant={severityVariant(event.severity)}>
            {t(`severity.${event.severity}`)}
          </StatusTag>
          <span className="text-xs text-muted-foreground">
            {formatThreatTime(event.timestamp, locale)}
          </span>
        </div>
        <p className="truncate text-sm font-medium">{t(event.titleKey)}</p>
        <p className="text-xs text-muted-foreground">
          {t(event.regionKey)} · {t(event.chainKey)}
        </p>
      </div>
    </GlassCard>
  ))

  return (
    <SectionContainer id="threats" className="py-12 md:py-20">
      <div className="mb-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center md:mb-8">
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <h2 className="text-2xl font-bold tracking-tight md:text-3xl">
              {t("title")}
            </h2>
            <LiveBadge label={t("live")} />
          </div>
          <p className="max-w-xl text-muted-foreground">{t("subtitle")}</p>
        </div>
      </div>

      <Marquee items={tickerItems} speed={40} className="py-2" />
    </SectionContainer>
  )
}
